import { c as _c } from "react/compiler-runtime";
import type { CustomStatusChanged } from '@onefootprint/request-types/dashboard';
import type { CustomTypeOptions } from 'i18next';
import { Trans } from 'react-i18next';
import Actor from './actor';
type CustomStatusChangedEventHeaderProps = {
  data: CustomStatusChanged;
};
const CustomStatusChangedEventHeader = t0 => {
  const $0 = _c(19);
  const {
    data
  } = t0;
  const {
    kind,
    value,
    actor
  } = data;
  let t1;
  if ($0[0] !== actor.kind || $0[1] !== value) {
    t1 = $ => {
      if (actor.kind === "footprint") {
        if (value === null) {
          return $.auditTrail.timeline.customStatusChangedEvent.onboardingEvent.cleared;
        }
        return $.auditTrail.timeline.customStatusChangedEvent.onboardingEvent.set;
      }
      if (value === null) {
        return $.auditTrail.timeline.customStatusChangedEvent.actorEvent.cleared;
      }
      return $.auditTrail.timeline.customStatusChangedEvent.actorEvent.set;
    };
    $0[0] = actor.kind;
    $0[1] = value;
    $0[2] = t1;
  } else {
    t1 = $0[2];
  }
  const getTransKey = t1;
  let t2;
  if ($0[3] !== kind.displayName) {
    t2 = <span className="font-semibold">{kind.displayName}</span>;
    $0[3] = kind.displayName;
    $0[4] = t2;
  } else {
    t2 = $0[4];
  }
  const t3 = value?.hexCode;
  let t4;
  if ($0[5] !== t3) {
    t4 = {
      color: t3
    };
    $0[5] = t3;
    $0[6] = t4;
  } else {
    t4 = $0[6];
  }
  const t5 = value?.displayName;
  let t6;
  if ($0[7] !== t4 || $0[8] !== t5) {
    t6 = <span className="font-semibold" style={t4}>{t5}</span>;
    $0[7] = t4;
    $0[8] = t5;
    $0[9] = t6;
  } else {
    t6 = $0[9];
  }
  let t7;
  if ($0[10] !== actor) {
    t7 = <Actor actor={actor} />;
    $0[10] = actor;
    $0[11] = t7;
  } else {
    t7 = $0[11];
  }
  let t8;
  if ($0[12] !== t2 || $0[13] !== t6 || $0[14] !== t7) {
    t8 = {
      status: t2,
      value: t6,
      actor: t7
    };
    $0[12] = t2;
    $0[13] = t6;
    $0[14] = t7;
    $0[15] = t8;
  } else {
    t8 = $0[15];
  }
  let t9;
  if ($0[16] !== getTransKey || $0[17] !== t8) {
    t9 = <div className="text-body-2 md:flex md:items-center md:gap-1"><Trans ns="entity-details" i18nKey={getTransKey} components={t8} /></div>;
    $0[16] = getTransKey;
    $0[17] = t8;
    $0[18] = t9;
  } else {
    t9 = $0[18];
  }
  return t9;
};
export default CustomStatusChangedEventHeader;